<p lang="sl-SI" align="center">
    <strong>Politika varstva osebnih podatkov in zasebnosti</strong>
</p>
<p lang="sl-SI">
    Namen politike varstva osebnih podatkov je seznaniti posameznike,
    uporabnike storitev, sodelavce, zaposlene ter druge osebe (v
nadaljevanju: »posameznik«) ter ponudnike storitev (v nadaljevanju "ponudniki storitev), ki sodelujejo z        <strong>Table42 d.o.o.</strong>, Vurnikov trg 3, 4240
    Radovljica (v nadaljevanju: »podjetje«) o namenih, pravnih podlagah,
    varnostnih ukrepih in pravicah posameznikov glede obdelave osebnih
    podatkov, ki jih izvaja naše podjetje.
</p>
<p lang="sl-SI">
    Podjetje je lastnik strani/portalov/aplikacij:
</p>
<p lang="sl-SI">
    <strong>table42.app</strong>
</p>
<p lang="sl-SI">
    <strong>www.</strong>
    <strong>table42.app</strong>
    <strong></strong>
</p>
<p lang="sl-SI">
    <strong>aplikacije table42.app</strong>
</p>
<p lang="sl-SI">
    <strong>
        Cenimo vašo zasebnost, zato vaše podatke vedno skrbno varujemo.
    </strong>
</p>
<p lang="sl-SI">
    Osebne podatke obdelujemo v skladu z evropsko zakonodajo (Uredba (EU)
    2016/697 o varstvu posameznikov pri obdelavi osebnih podatkov in o
    pretoku takih podatkov (v nadaljevanju: »Splošna uredba«)), veljavno
    slovensko zakonodajo s področja varstva osebnih podatkov in drugo
    zakonodajo, ki daje pravno podlago za obdelavo osebnih podatkov podjetju in ponudnikom storitev.
</p>
<p lang="sl-SI">
    Politika varstva osebnih podatkov vsebuje informacije, na kak način podjetje in ponudniki storitev kot upravljalci obdeluje osebne podatke, ki jih prejmejo od
    posameznika na osnovi pravnih podlag, ki jih opisujemo v nadaljevanju.
</p>
<h1 lang="sl-SI">
    1) Upravljavec 1 - Podjetje
</h1>
<p lang="sl-SI">
    Upravljavec osebnih podatkov je podjetje:
</p>
<p lang="sl-SI">
    <strong>Table42, d.o.o.</strong>
</p>
<p lang="sl-SI">
    Vurnikov trg 3, 4240 Radovljica
</p>
<p lang="sl-SI">
    E-pošta: stik@table42.app
</p>
<p lang="sl-SI">
    Telefon: +386 31312038
</p>
<h1 lang="sl-SI">
    Upravljavec 2 - Ponudnik storitve</h1>
<p lang="sl-SI">Upravljavec 2, za katero je preko spletnega portala posameznik izvedel
    rezervacijo. Lahko gre za obstoječo stranko ponudnika storitve, ki jo ima ponudnik storitve že
    shranjeno v svoji podatkovni bazi na osnovi druge pogodbene obdelave osebnih podatkov. To se ob
    vnosu podatkov posameznika preveri preko programskega vmesnika (APIja).
</p>
<h1 lang="sl-SI">
    2) Kontaktna oseba za varstvo osebnih podatkov
</h1>
<p lang="sl-SI">
    Posamezniki, na katere se nanašajo osebni podatki, lahko glede vseh
    vprašanj, povezanih z obdelavo njihovih osebnih podatkov in
    uresničevanjem njihovih pravic v skladu s Splošno uredbo stopijo v
    kontakt s kontaktno osebo za varstvo osebnih podatkov, ki je dosegljiva
    po e-pošti: <em>stik@table42.app</em> Podjetje je dolžno o tem takoj obvestiti upravljalca 2.
</p>
<h1 lang="sl-SI">
    3) Osebni podatki
</h1>
<p lang="sl-SI">
    Osebni podatek pomeni katero koli informacijo v zvezi z določenim ali
    določljivim posameznikom; določljiv posameznik je tisti, ki ga je
    mogoče neposredno ali posredno določiti, zlasti z navedbo
    identifikatorja, kot je ime, identifikacijska številka, podatki o
    lokaciji, spletni identifikator, ali z navedbo enega ali več
    dejavnikov, ki so značilni za fizično, fiziološko, genetsko, duševno,
    gospodarsko, kulturno ali družbeno identiteto tega posameznika.
</p>
<h1 lang="sl-SI">
    4) Nameni obdelave in podlage za obdelavo podatkov
</h1>
<p lang="sl-SI">
    Podjetje in ponudniki storitev zbirajo in obdelujejo vaše osebne podatke na naslednjih pravnih
    podlagah:
</p>
<ul>
    <li>
        <p lang="sl-SI">
obdelava je potrebna za izpolnitev                <strong>zakonske obveznosti</strong>, ki velja za upravljavce;
        </p>
    </li>
    <li>
        <p lang="sl-SI">
            obdelava je potrebna za <strong>izvajanje pogodbe</strong>,
            katere pogodbena stranka je posameznik, na katerega se
            nanašajo osebni podatki, ali za izvajanje ukrepov na zahtevo
            takega posameznika pred sklenitvijo pogodbe;
        </p>
    </li>
    <li>
        <p lang="sl-SI">
obdelava je potrebna zaradi                <strong>zakonitih interesov </strong>za katere si prizadevajo
            upravljavci ali tretja oseba;
        </p>
    </li>
    <li>
        <p lang="sl-SI">
posameznik, na katerega se nanašajo osebni podatki, je                <strong>privolil</strong> v obdelavo njegovih osebnih podatkov
            v enega ali več določenih namenov;
        </p>
    </li>
    <li>
        <p lang="sl-SI">
obdelava je potrebna za                <strong>zaščito življenjskih interesov</strong> posameznika,
            na katerega se nanašajo osebni podatki, ali druge fizične
            osebe.
        </p>
    </li>
</ul>
<p lang="sl-SI">
    <strong>4.1) Izpolnitev zakonske obveznosti</strong>
</p>
<p lang="sl-SI">
    Na osnovi določil v zakonu podjetje obdeluje podatke o svojih
    zaposlenih, kar mu omogoča delovnopravna in socialnovarstvena
    zakonodaja. Podjetje na podlagi zakonske obveznosti za namene
    zaposlovanja obdeluje predvsem naslednje vrste osebnih podatkov: ime in
    priimek, spol, datum rojstva, EMŠO, davčno številko, kraj, občino in
    državo rojstva, državljanstvo, prebivališče ipd.
</p>
<p lang="sl-SI">
    <strong>4.2) Izvajanje pogodbe</strong>
</p>
<p lang="sl-SI" align="justify">
    V primeru, ko s podjetjem (in posredno s ponudniki storitev) kot posameznik sklenete pogodbo, ta
    predstavlja pravno podlago za obdelavo osebnih podatkov. Pogodba vam
    zagotavlja koriščenje mnogih ugodnosti.
</p>
<p lang="sl-SI" align="justify">
    Z začetkom uporabe naših storitev potrjujete, da ste prebrali Splošne
    pogoje poslovanja, ki so sestavni del pogodbe, ter jih razumete in v
    celoti sprejemate.
</p>
<p lang="sl-SI" align="justify">
    <br/>
    Vaše osebne podatke, ki nam jih boste posredovali ali nam jih bo
    posredovale tretje osebe na podlagi vaše zahteve bomo obdelovali za
    namen zagotavljanja vaših pravic iz te pogodbe, za preverjanje
    skladnosti uporabe s splošnimi pogoji poslovanja, za namen ocenjevanja
    ponudbe, optimiziranja ponudb ter stroškov ter dvig zadovoljstva
    kupcev, pri reševanju vaših vprašanj, pobud, ugovorov ali reklamacij
    ter za obveščanje o tehničnih, pravnih in drugih vprašanjih. Občasno
    vas bomo zaprosili za povratne informacije o zadovoljstvu z uporabo
    naše storitve. Podatke bomo obdelovali za namenom priprave posebnih
    ponudb in vas o njih obvestili na način, ki ga boste sami izbrali (na
    e-naslov, sms, ali v aplikaciji). Če posameznik osebnih podatkov ne
    posreduje, podjetje ne more skleniti pogodbe, prav tako vam podjetje ne
    more izvesti storitve oziroma dostaviti blaga v skladu s sklenjeno
    pogodbo, saj nima potrebnih podatkov za izvedbo.
</p>
<p lang="sl-SI" align="justify">
    <a name="_Hlk39669227"></a>
    <br/>
    Vaše osebne podatke smemo tako obdelovati za sklenitev in izvajanje
    pogodbe, kot je npr. prodaja blaga in storitev, članstvo v klubih
    ugodnosti, udeležba dogodkih, izobraževanjih, promocijah ipd.. Podjetje
    lahko na podlagi opravljanja zakonite dejavnosti posameznike in
    uporabnike njenih storitev na njihov elektronski naslov obvešča o
    svojih o storitvah, dogodkih, izobraževanjih, ponudbah in drugih
    vsebinah. Posameznik lahko kadarkoli zahteva prekinitev tovrstnega
    komuniciranja in obdelave osebnih podatkov ter prekliče prejemanje
    sporočil preko povezave za odjavo v prejetem sporočilu, ali kot
    zahtevek po elektronski pošti na <em>hello@pricepilot.io</em> ali z
    redno pošto na naslov podjetja.
</p>
<p lang="sl-SI">
    <strong>4.3) Zakoniti interes</strong>
</p>
<p lang="sl-SI">
    Podjetje lahko osebne podatke obdeluje tudi na podlagi zakonitega
    interesa, za katerega si prizadeva. Slednje ni dopustno, kadar nad
    takimi interesi prevladajo interesi ali temeljne pravice in svoboščine
    posameznika, na katerega se nanašajo osebni podatki, ki zahtevajo
    varstvo osebnih podatkov. V primeru uporabe zakonitega interesa
    podjetje vedno opravi presojo skladno s Splošno uredbo.
</p>
<p lang="sl-SI">
    Obdelava osebnih podatkov posameznikov za namene neposrednega trženja
    se šteje za opravljeno v zakonitem interesu. Upravjavec lahko obdeluje
    osebne podatke posameznikov, ki jih je zbralo iz javno dostopnih virov
    ali v okviru zakonitega opravljanja dejavnosti, tudi za namene
    ponujanja blaga, storitev, zaposlitev, obveščanja o ugodnostih,
    dogodkih ipd. Za dosego teh namenov lahko podjetje uporablja navadno
    pošto, telefonske klice, elektronsko pošto in druga telekomunikacijska
    sredstva. Za namene neposrednega trženja lahko podjetje obdeluje
    naslednje osebne podatke posameznikov: ime in priimek posameznika,
    naslov stalnega ali začasnega prebivališča, telefonsko številko in
    naslov elektronske pošte. Navedene osebne podatke lahko za namene
    neposrednega trženja podjetje obdeluje tudi brez izrecne privolitve
    posameznika. Posameznik lahko kadarkoli zahteva prekinitev tovrstnega
    komuniciranja in obdelave osebnih podatkov ter prekliče prejemanje
    sporočil preko povezave za odjavo v prejetem sporočilu, ali kot
    zahtevek po elektronski pošti na <em>stik@table42.app</em> ali z
    redno pošto na naslov upravljavca. Upravljavec 1 mora o tem nemudoma pisno obvestiti upravljavce 2.
</p>
<p lang="sl-SI">
    <strong>4.4) Obdelava na podlagi privolitve oz. soglasja</strong>
</p>
<p lang="sl-SI">
    V kolikor upravljavec nima pravne podlage izkazane na osnovi zakona,
    pogodbene obveznosti ali zakonitega interesa, sme posameznika zaprositi
    za privolitev oz. soglasje. Tako lahko obdeluje določene osebne podatke
    posameznika tudi za naslednje namene, kadar posameznik poda za to
    soglasje:
</p>
<ul>
    <li>
        <p lang="sl-SI">
            naslov prebivališča in naslov elektronske pošte za namene
            obveščanja in komunikacije;
        </p>
    </li>
    <li>
        <p lang="sl-SI">
            druge namene, za katere se posameznik strinja s privolitvijo.
        </p>
    </li>
</ul>
<p lang="sl-SI">
    Če posameznik poda soglasje za obdelavo osebnih podatkov in v nekem
    trenutku tega več ne želi, lahko zahteva prekinitev obdelave osebnih
podatkov z zahtevkom po elektronski pošti na        <em>stik@table42.app</em> ali z redno pošto na naslov upravljavca.
    Preklic privolitve ne vpliva na zakonitost obdelave na podlagi
    privolitve pred njenim preklicem. Upravljavec 1 mora o tem
nemudoma pisno obvestiti upravljavce 2.
</p>
<p lang="sl-SI">
    <strong>
        4.5) Obdelava je potrebna za zaščito življenjskih interesov
        posameznika
    </strong>
</p>
<p lang="sl-SI">
    Upravljavec lahko obdeluje osebne podatke posameznika, na katerega se
    nanašajo osebni podatki, v kolikor je to nujno za zaščito njegovih
    življenjskih interesov. V nujnih primerih lahko upravljavec poišče osebni
    dokument posameznika, preveri ali ta oseba obstaja v njegovi zbirki
    podatkov, preuči njegovo anamnezo ali naveže stik z njegovimi svojci,
    za kar upravljavec ne potrebuje posameznikove privolitve. Navedeno velja v
    primeru, ko je to nujno potrebno za zaščito življenjskih interesov
    posameznika.
</p>
<h1 lang="sl-SI">
    5) Hramba in izbris osebnih podatkov
</h1>
<p lang="sl-SI">
    Podjetje bo hranilo osebne podatke le toliko časa, dokler bo to
    potrebno za uresničitev namena, zaradi katerega so bili osebni podatki
    zbrani in obdelovani. V kolikor upravljavec podatke obdeluje na podlagi
    zakona, jih bo hranilo za obdobje, ki ga predpisuje zakon. Pri tem se
    nekateri podatki hranijo za časa sodelovanja s upravljavcem, nekatere
    podatke pa je treba hraniti trajno.
</p>
<p lang="sl-SI">
    Osebne podatke, ki jih upravljavec obdeluje na osnovi pogodbenega odnosa s
    posameznikom, upravljavec hrani za obdobje, ki je potrebno za izvršitev
    pogodbe in še 6 let po njenem prenehanju, razen v primerih, ko pride
    med posameznikom in upravljavcem do spora v zvezi s pogodbo. V takem
    primeru hrani upravljavec podatke še 10 let po pravnomočnosti sodne
    odločbe, arbitraže ali sodne poravnave ali, če sodnega spora ni bilo, 5
    let od dneva mirne razrešitve spora. Tiste osebne podatke, ki jih
    upravljavec obdeluje na podlagi osebne privolite posameznika ali
    zakonitega interesa, bo upravljavec hranilo do preklica privolitve ali do
    zahteve za izbris podatkov. Po prejemu zahteve za preklic privolitve
    ali zahteve za izbris se podatki izbrišejo brez nepotrebnega odlašanja,
    v vsakem primeru pa v enem mesecu po prejemu zahteve. Ta rok se lahko
    po potrebi podaljša za največ dva dodatna meseca ob upoštevanju
    kompleksnosti in števila zahtev. Organizacija obvesti posameznika, na
    katerega se nanašajo osebni podatki, o vsakem takem podaljšanju v enem
    mesecu po prejemu zahteve skupaj z razlogi za zamudo. Izjema velja za
    tiste osebne podatke, pri katerih rok hrambe določa zakon. Podjetje
    lahko te podatke izbriše tudi pred preklicem, kadar je bil dosežen
    namen obdelave osebnih podatkov ali če tako določa zakon.
</p>
<p lang="sl-SI">
    Izjemoma lahko upravljavec zavrne zahtevo za izbris iz razlogov iz Splošne
    uredbe, kot so našteti: uresničevanje pravice do svobode izražanja in
    obveščanja, izpolnjevanje pravne obveznosti obdelave, razlogi javnega
    interesa na področju javnega zdravja, nameni arhiviranja v javnem
    interesu, znanstveno- ali zgodovinsko raziskovalne nameni ali
    statistični nameni, izvajanje ali obramba pravnih zahtevkov. Po preteku
    obdobja hrambe mora upravljavec osebne podatke učinkovito in trajno
    izbrisati ali anonimizirati, tako da jih ni več mogoče povezati z
    določenim posameznikom.
</p>
<h1 lang="sl-SI">
    6) Pogodbena obdelava osebnih podatkov in iznos podatkov
</h1>
<p lang="sl-SI">
    Upravljavec lahko za posamezne obdelave osebnih podatkov na osnovi pogodbe
    o pogodbeni obdelavi zaupa pogodbenemu obdelovalcu. Pogodbeni
    obdelovalci lahko zaupane podatke obdelujejo izključno v imenu
    upravljavca, v mejah njegovega pooblastila, ki je zapisan v pisni
    pogodbi oziroma drugem pravnem aktu in skladno z nameni, ki so
    opredeljeni v tej politiki zasebnosti.
</p>
<p lang="sl-SI">
    Pogodbeni obdelovalci, s katerimi sodeluje podjetje so predvsem:
</p>
<ul>
    <li>
        <p lang="sl-SI">
            računovodske storitve in drugi ponudniki pravnega ter
            poslovnega svetovanja;
        </p>
    </li>
    <li>
        <p lang="sl-SI">
            vzdrževalci infrastrukture (videonadzor, varnostne storitve);
        </p>
    </li>
    <li>
        <p lang="sl-SI">
            vzdrževalci informacijskih sistemov;
        </p>
    </li>
    <li>
        <p lang="sl-SI">
            ponudniki e-poštnih storitev in ponudniki programske opreme,
            storitev v oblaku (npr. Arnes, Microsoft, Google);
        </p>
    </li>
    <li>
        <p lang="sl-SI">
            ponudniki družabnih omrežij in spletnega oglaševanja (Google,
            Facebook, Instagram ipd.).
        </p>
    </li>
</ul>
<p lang="sl-SI">
    Upravljavec v nobenem primeru ne bo posredovalo osebnih podatkov
    posameznika tretjim nepooblaščenim osebam. Pogodbeni obdelovalci smejo
    osebne podatke obdelovati zgolj v okviru navodil podjetja in osebnih
    podatkov ne smejo uporabiti za katerekoli druge namene.
</p>
<p lang="sl-SI">
    Podjetje in ponudniki storitev kot upravljavci in njeni zaposleni osebnih podatkov ne
    iznašajo v tretje države (izven držav članic Evropskega gospodarskega
    prostora – članice EU ter Islandija, Norveška in Liechtenstein) in v
    mednarodne organizacije, razen v ZDA, pri čemer so pogodbeni
    obdelovalci iz ZDA vključeni v program Zasebnostnega ščita EU-ZDA
    (Privacy Shield). Več o Zasebnostnem ščitu EU-ZDA na spletnih straneh
    Informacijskega pooblaščenca:
    <u>
        <a
            href="https://www.ip-rs.si/varstvo-osebnih-podatkov/obveznosti-upravljavcev/iznos-osebnih-podatkov-v-tretje-drzave/iznos-osebnih-podatkov-v-zda/"
        >
            https://www.ip-rs.si/varstvo-osebnih-podatkov/obveznosti-upravljavcev/iznos-osebnih-podatkov-v-tretje-drzave/iznos-osebnih-podatkov-v-zda/
        </a>
    </u>
    .
</p>
<h1 lang="sl-SI">
    7) Piškotki
</h1>
<p lang="sl-SI">
    Spletna stran podjetja deluje s pomočjo t.i. piškotkov (angl. cookies).
    Piškotek je datoteka, ki shrani nastavitve spletnih strani. Spletna
    mesta piškotke shranijo v naprave uporabnikov, s katerimi dostopajo do
    interneta z namenom prepoznavanja posameznih naprav in nastavitev, ki
    so jih uporabniki uporabili pri dostopu. Piškotki omogočajo spletnim
    stranem prepoznavanje, v kolikor je uporabnik že obiskal spletno mesto.
    Pri naprednih aplikacijah se lahko z njihovo pomočjo ustrezno
    prilagodijo posamezne nastavitve. Njihovo shranjevanje je pod popolnim
    nadzorom brskalnika, ki ga uporablja posameznik – ta lahko shranjevanje
    piškotkov po želji omeji ali onemogoči.
</p>
<p lang="sl-SI">
    Piškotki so temeljnega pomena za zagotavljanje posamezniku prijaznih
    spletnih storitev. Uporabljajo se za shranjevanje podatkov o stanju
    posamezne spletne strani, pomagajo pri zbiranju statistik o uporabnikih
    in obiskanosti spletnega mesta, itd. S pomočjo piškotkov ocenimo
    učinkovitost zasnove našega spletnega mesta.
</p>
<p lang="sl-SI">
    Spletna stran podjetja uporablja naslednje piškotke:
</p>
<table width="604" cellpadding="7" cellspacing="0">
    <colgroup>
        <col width="98"/>
        <col width="90"/>
        <col width="372"/>
    </colgroup>
    <tbody>
        <tr valign="top">
            <td width="98">
                <p lang="sl-SI">
                    Ime piškotka
                </p>
            </td>
            <td width="90">
                <p lang="sl-SI">
                    Čas trajanja
                </p>
            </td>
            <td width="372">
                <p lang="sl-SI">
                    Funkcija
                </p>
            </td>
        </tr>
        <tr valign="top">
            <td width="98">
                <p lang="sl-SI">
                    _ga
                </p>
            </td>
            <td width="90">
                <p lang="sl-SI">
                    2 leti
                </p>
            </td>
            <td width="372">
                <p lang="sl-SI">
                    Uporablja se za razlikovanje med uporabniki.
                </p>
            </td>
        </tr>
        <tr valign="top">
            <td width="98">
                <p lang="sl-SI">
                    _gid
                </p>
            </td>
            <td width="90">
                <p lang="sl-SI">
                    24 ur
                </p>
            </td>
            <td width="372">
                <p lang="sl-SI">
                    Uporablja se za razlikovanje med uporabniki.
                </p>
            </td>
        </tr>
        <tr valign="top">
            <td width="98">
                <p lang="sl-SI">
                    _gat
                </p>
            </td>
            <td width="90">
                <p lang="sl-SI">
                    1 minuta
                </p>
            </td>
            <td width="372">
                <p lang="sl-SI">
                    Uporablja se za uravnavanje dostopov do spletne strani.
                </p>
            </td>
        </tr>
        <tr valign="top">
            <td width="98">
                <p lang="sl-SI">
                    _gali
                </p>
            </td>
            <td width="90">
                <p lang="sl-SI">
                    24 ur
                </p>
            </td>
            <td width="372">
                <p lang="sl-SI">
                    Izboljšana dodelitev povezav.
                </p>
            </td>
        </tr>
    </tbody>
</table>
<p lang="sl-SI">
    Piškotke, ki jih je brskalnik shranil, lahko posameznik izbriše
    (navodila se nahajajo na spletnih straneh posameznega brskalnika).
</p>
<h1 lang="sl-SI">
    8) Varovanje podatkov in točnost podatkov
</h1>
<p lang="sl-SI">
    Upravljavec skrbi za informacijsko varnost in varnost infrastrukture
    (prostorov in aplikativno sistemske programske opreme). Informacijski sistemi so med drugim zaščiteni s protivirusnimi programi in požarnim zidom. Uvedli smo ustrezne organizacijsko tehnične
    varnostne ukrepe, namenjene varstvu osebnih podatkov pred naključnim
    ali nezakonitim uničenjem, izgubo, spreminjanjem, nepooblaščenim
    razkrivanjem ali dostopom ter pred drugimi nezakonitimi in
    nepooblaščenimi oblikami obdelave. V primeru posredovanja posebnih vrst
    osebnih podatkov, jih posredujemo v šifrirani obliki in zaščiteni z
    geslom.
</p>
<p lang="sl-SI">
    Posameznik je sam odgovoren, da svoje osebne podatke posreduje varno in
    da so posredovani podatki točni in verodostojni. Podjetje se bo
    trudilo, da bodo osebni podatki, ki jih obdeluje, točni in po potrebi
    ažurirani, občasno se lahko obrnemo tudi na posameznika za potrditev
    točnosti osebnih podatkov.
</p>
<h1 lang="sl-SI">
    9) Pravice posameznika glede obdelave podatkov
</h1>
<p lang="sl-SI">
    V skladu s Splošno uredbo ima posameznik sledeče pravice iz varstva
    osebnih podatkov:
</p>
<ul>
    <li>
        <p lang="sl-SI">
            Zahteva lahko informacije o tem, ali imamo njegove osebne
            podatke in, če je tako, katere podatke imamo ter na kakšni
            podlagi jih imamo in zakaj jih uporabljamo;
        </p>
    </li>
    <li>
        <p lang="sl-SI">
            zahteva lahko dostop do svojih osebnih podatkov, kar mu
            omogoča, da prejme kopijo osebnih podatkov, ki jih ima podjetje
            ter preveri, ali jih podjetje obdeluje zakonito;
        </p>
    </li>
    <li>
        <p lang="sl-SI">
            zahteva lahko popravke osebnih podatkov, kot je popravek
            nepopolnih ali netočnih osebnih podatkov;
        </p>
    </li>
    <li>
        <p lang="sl-SI">
            zahteva lahko izbris svojih osebnih podatkov, kadar ni razloga
            za nadaljnjo obdelavo oziroma kadar uveljavlja svojo pravico do
            ugovora glede nadaljnje obdelave;
        </p>
    </li>
    <li>
        <p lang="sl-SI">
            ugovarja lahko nadaljnji obdelavi osebnih podatkov, kjer se
            podjetje sklicuje na zakoniti poslovni interes (tudi v primeru
            zakonitega interesa tretje osebe), kadar obstajajo razlogi,
            povezani s posameznikovim posebnim položajem; posameznik ima
            pravico kadarkoli ugovarjati, če podjetje obdeluje osebne
            podatke za namene neposrednega trženja;
        </p>
    </li>
    <li>
        <p lang="sl-SI">
            zahteva lahko omejitev obdelave svojih osebnih podatkov, kar
            pomeni prekinitev obdelave osebnih podatkov, na primer, če
            posameznik želi, da podjetje ugotovi točnost ali da se
            preverijo razlogi za nadaljnjo obdelavo osebnih podatkov;
        </p>
    </li>
    <li>
        <p lang="sl-SI">
            zahteva lahko prenos svojih osebnih podatkov v strukturirani
            elektronski obliki k drugemu upravljavcu, v kolikor je to
            mogoče in izvedljivo;
        </p>
    </li>
    <li>
        <p lang="sl-SI">
            prekliče lahko privolitev oziroma soglasje, ki ga podal za
            zbiranje, obdelavo in prenos svojih osebnih podatkov za določen
            namen; po prejemu obvestila, da je umaknil svojo privolitev, bo
            podjetje prenehalo obdelovati osebne podatke za namene, ki jih
            prvotno sprejel, razen če podjetje nima druge zakonite pravne
            podlage za to, da to stori zakonito.
        </p>
    </li>
</ul>
<p lang="sl-SI">
    Če želi posameznik uveljavljati katero koli od prej navedenih pravic,
lahko pošlje zahtevek po elektronski pošti na        <em>stik@table42.app</em> ali z redno pošto na naslov upravljavca.
    Dostop do posameznikovih osebnih podatkov in uveljavljene pravic je za
    posameznika brezplačno. Vendar pa lahko upravljavec zaračuna razumno
    plačilo, v kolikor je zahteva posameznika, na katerega se nanašajo
    osebni podatki, očitno neutemeljena ali pretirana, zlasti če se
    ponavlja. V takšnem primeru lahko upravljavec zahtevo tudi zavrne. V
    primeru uveljavljanja pravic iz tega naslova bo morebiti moralo
    upravljavec od posameznika zahtevati določene informacije, ki mu bodo
    pomagale pri potrditvi identitete posameznika, kar je le varnostni
    ukrep, ki zagotavlja, da se osebni podatki ne razkrijejo nepooblaščenim
    osebam.
</p>
<p lang="sl-SI">
    Pri uveljavljanju pravic iz tega naslova lahko posameznik uporabi
    obrazec Informacijskega pooblaščenca, ki je dosegljiv na njihovi
    spletni strani. Povezava na:
    <u>
        <a
            href="https://www.ip-rs.si/fileadmin/user_upload/doc/obrazci/ZVOP/Zahteva_za_seznanitev_z_lastnimi_osebnimi_podatki__Obrazec_SLOP_.doc"
        >
            https://www.ip-rs.si/fileadmin/user_upload/doc/obrazci/ZVOP/Zahteva_za_seznanitev_z_lastnimi_osebnimi_podatki__Obrazec_SLOP_.doc
        </a>
    </u>
</p>
<p lang="sl-SI">
    V primeru, da posameznik meni, da so mu pravice kršene, se lahko za
    zaščito ali pomoč obrne na nadzorni organ (Informacijskega
    pooblaščenca). Povezava na:
    <u>
        <a
            href="https://www.ip-rs.si/zakonodaja/reforma-evropskega-zakonodajnega-okvira-za-varstvo-osebnih-podatkov/kljucna-podrocja-uredbe/prijava-krsitev/"
        >
            https://www.ip-rs.si/zakonodaja/reforma-evropskega-zakonodajnega-okvira-za-varstvo-osebnih-podatkov/kljucna-podrocja-uredbe/prijava-krsitev/
        </a>
    </u>
</p>
<p lang="sl-SI">
    Če ima posameznik kakršnakoli vprašanja v zvezi z obdelavo svojih
    osebnih podatkov, se lahko vedno obrnete na upravljavca preko
    elektronske pošte na <em>stik@table42.app</em> ali z redno pošto na
    naslov podjetja. Upravljavec 1 mora o tem nemudoma pisno obvestiti upravljavce 2.
</p>
<h1 lang="sl-SI">
    10) Objava sprememb
</h1>
<p lang="sl-SI">
    Vsaka sprememba Politike o varstvu osebnih podatkov bo objavljena
    na spletnih straneh ali v aplikacijah v lasti podjetja.
</p>
<p lang="sl-SI">
    Z uporabo spletne strani posameznik potrjuje, da sprejema in soglaša s
    celotno vsebino te politike varstva osebnih podatkov.
</p>
<p lang="sl-SI">
    Politiko varstva osebnih podatkov je sprejel direktor Mitja Poljšak
    dne, 15. 09. 2022 in so del pogodbe o obdelavi osebnih podatkov med podjetjem (upravljavcem 1) in ponudniki storitev (upravljavec 2).
</p>
<p lang="sl-SI" align="right">
    <strong>Table42 d.o.o.</strong>
    ,
</p>
<p lang="sl-SI" align="right">
    Mitja Poljšak, direktor
</p>
